export default __webpack_public_path__ + "static/media/graph-with-magnifying-glass-icon.8e9a97a2.svg";